import apiClient from './client'
import type { MapConfig, MapPlatform, ReverseGeocodeResult } from '@/types'

export const mapsApi = {
  config: async (platform: MapPlatform = 'web'): Promise<MapConfig> => {
    const { data } = await apiClient.get<MapConfig>(`/me/map-config/?platform=${platform}`)
    return data
  },

  reverseGeocode: async (
    lat: number,
    lng: number,
    options: { regionCode?: string; languageCode?: string } = {}
  ): Promise<ReverseGeocodeResult> => {
    const { data } = await apiClient.post<ReverseGeocodeResult>('/geocoding/reverse/', {
      lat,
      lng,
      region_code: options.regionCode,
      language_code: options.languageCode,
    })
    return data
  },
}
